import React, { useState, useEffect } from "react";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import apiService from "./services/api.service";
import "./i18n/config";
import { t } from "i18next";
import { Fragment } from "react";

const FilterDropdownComponent = ({ products, chainId, lang, setProductsFiltered }) => {
    const [allProperties, setAllProperties] = useState([]);
    const [properties, setProperties] = useState([])
    const [categories, setCategories] = useState([]);
    const [filterNeeded, setFilterNeeded] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("")
    const [cities, setCities] = useState([])
    const [selectedProperty, setSelectedProperty] = useState("")

    useEffect(() => {
        getProperties(chainId)
    }, []);

    useEffect(() => {
        if(sessionStorage.getItem("chain")){
            const chain = JSON.parse(sessionStorage.getItem("chain"));
            if(chain.filterByCategory){
                getCategories();
            }
        }
    }, [products])

    useEffect(() => {
        getCities(chainId)
    }, [chainId])

    useEffect(() => {
        if (allProperties.length && products.length && !filterNeeded) {
            setFilterNeeded(true);
        }
    }, [allProperties, products])

    useEffect(() => {
        let propertiesFiltered = [];
        for (let property of allProperties) {
            if (products.some(product => product.propertyId === property.propertyId)) {
                propertiesFiltered.push(property);
            }
        }
        setProperties(propertiesFiltered);
    }, [filterNeeded, products])


    const getCategories = () => {
        let categories = []
        products.map((product) => {
            if (product.categories) {
                product.categories.map((category) => {
                    categories.push(category)
                })
            }
        })
        //remove duplicates 
        if (categories) {
            setCategories(categories.filter((v, i, a) => a.findIndex(v2 => (v.productCategoryId === v2.productCategoryId)) === i))
        }
    }

    const getProperties = (chainId) => {
        apiService.getProperties(chainId)
            .then((response) => {
                setAllProperties(response.data.data)
                sessionStorage.setItem( "properties" , JSON.stringify(response.data.data))
            },
                (error) => {
                    console.log(error);
                }
            )
    }

    const selectPropertyHandler = (product) => {
        if (product) {
            setProductsFiltered(products.filter((pr) => pr.propertyId == product.propertyId))
            setSelectedProperty(getPropertyName(product))
        } else {
            setProductsFiltered(products)
            setSelectedProperty(t("showAll"))
        }
    }

    const getPropertyName = (property) => {
        if (property.propertyTranslations && property.propertyTranslations.length) {
            const propertyTranslation = property.propertyTranslations.find(t => t.languageIsoCode == lang);
            if (propertyTranslation) {
                return propertyTranslation.propertyName
            }
        }
        return property.name;
    }
    const getCities = (chainId) => {
        apiService.getCities(chainId)
            .then((response) => {
                let data = response.data.data
                setCities(data)
            },
                (error) => {
                    console.log(error);
                }
            )
    }

    const getCityName = (city) => {
        if (city.translations && city.translations.length) {
            const cityTranslation = city.translations.find(t => t.languageIsoCode == lang);
            if (cityTranslation) {
                return cityTranslation.cityName
            }
        }
        return city.internationalName;
    }

    const getCategoryName = (category) => {
        if (category.translations && category.translations.length) {
            return category.translations[0].productCategoryName
        }
        return category.productCategoryName
    }

    const getPropertiesByCity = (city) => {
        return properties.filter(p => p.cityId === city.cityId)
    }

    const selectCategoryHandler = (category) => {
        if(!category){
            setSelectedCategory(t("showAll"))
            setProductsFiltered(products)
        }else{
            let productsByCategory = []
            for (let p of products) {
                for(let c of p?.categories){
                    if(c.productCategoryId === category.productCategoryId){
                        productsByCategory.push(p)
                    }
                }
            }
            setProductsFiltered(productsByCategory)
            setSelectedCategory(getCategoryName(category))
        }
    }

    const getProductsAmount = (c) => {
        let cnt = 0;
        if (!c) {
            return products.length
        } else {
            for (let p of products) {
                if(p.categories){
                    for(let pc of p.categories){
                        if (pc.productCategoryId === c.productCategoryId) {
                            cnt++
                        }
                    }
                }
            }
            return cnt
        }
    }

    return <div className="filter">
        {
            !!cities.length && properties.length > 1 &&
            <>
                <div className="filter-section">
                    <label className="filter-label" htmlFor="hotel-filter">{t("filterBy")} {t("hotel")}</label>
                    <DropdownButton id="hotel-filter" className="custom-dropdown" title={selectedProperty ? selectedProperty : t("showAll")}>
                        {cities.map((c, i) => {
                            return getPropertiesByCity(c).length > 0 &&
                                <Fragment key={i}>
                                    <Dropdown.Item as="h5" aria-readonly eventKey={i} aria-label={getCityName(c)}>{getCityName(c)}</Dropdown.Item>

                                    {getPropertiesByCity(c)
                                        .map((p , ii) =>
                                            <Dropdown.Item key={ii} as="button" className="custom-button" aria-label={getPropertyName(p)} value={p.propertyId} onClick={e => selectPropertyHandler(p)}>{getPropertyName(p)}</Dropdown.Item>)}
                                </Fragment>
                        }
                        )}
                        <Dropdown.Divider />
                        <Dropdown.Item as="button" className="custom-button" aria-label={t("showAll") + " " + properties.length + " " + t("results")} value={""} onClick={e => selectPropertyHandler()} key={""}>{t("showAll")} <span className="amount">({properties.length})</span></Dropdown.Item>
                    </DropdownButton>
                </div>
            </>
        }
        {
            !!categories && categories.length > 1 &&
            <div className="filter-section">
                <label className="filter-label" htmlFor="category-filter">{t("filterBy")} {t("category")}</label>
                <DropdownButton id="category-filter" className="custom-dropdown" aria-label={t("filterBy") + " " + t("category")} title={selectedCategory ? selectedCategory : t("showAll")}>
                    {categories.map((c , i) => {
                        {
                            return getProductsAmount(c) > 0 &&
                                <Dropdown.Item as="button" className="custom-button" aria-label={getCategoryName(c) + " " + getProductsAmount(c) + " " + t("results")} value={c.productCategoryId} onClick={e => selectCategoryHandler(c)} key={i}>{getCategoryName(c)} <span className="amount">({getProductsAmount(c)})</span></Dropdown.Item>
                                
                        }
                    })}
                    <Dropdown.Item as="button" className="custom-button" aria-label={t("showAll") + " " + getProductsAmount() + " " + t("results")} value={""} onClick={e => selectCategoryHandler()} key={""}>{t("showAll")}<span className="amount">({getProductsAmount()})</span></Dropdown.Item>
                </DropdownButton>
            </div>
        }
    </div>

}
export default FilterDropdownComponent